export default "__VITE_ASSET__4SY8zUUe__"